import React from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import {
	SIDE_NAV_WIDTH,
	SIDE_NAV_DARK,
	NAV_TYPE_SIDE,
	NAV_TYPE_TOP,
} from "constants/ThemeConstant";
import { toggleCollapsedNav, onMobileNavToggle } from "redux/actions/Theme";
import MenuContent from "./MenuContent";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

const { Sider } = Layout;

export const SideNav = ({
	navCollapsed,
	sideNavTheme,
	routeInfo,
	hideGroupTitle,
	localization = true,
	navType,
	isMobile,
	toggleCollapsedNav,
	onMobileNavToggle,
	mobileNav,
}) => {
	const props = { sideNavTheme, routeInfo, hideGroupTitle, localization };
	const isNavTop = navType === NAV_TYPE_TOP ? true : false;

	const onToggle = () => {
		if (!isMobile) {
			toggleCollapsedNav(!navCollapsed);
		} else {
			onMobileNavToggle(!mobileNav);
		}
	};

	const getToggleSquareClasses = () => {
		const classes = ["toggle-menu-square"];

		if (navCollapsed) {
			classes.push("collapsed");
		} else {
			classes.push("expanded");
		}

		return classes.join(" ");
	};

	return (
		<>
			<Sider
				className={`side-nav ${
					sideNavTheme === SIDE_NAV_DARK ? "side-nav-dark" : ""
				}`}
				width={SIDE_NAV_WIDTH}
				collapsed={navCollapsed}
			>
				<MenuContent type={NAV_TYPE_SIDE} {...props} />
			</Sider>
			{isNavTop && !isMobile ? null : (
				<div
					className={getToggleSquareClasses()}
					onClick={() => {
						onToggle();
					}}
				>
					{navCollapsed || isMobile ? (
						<MenuUnfoldOutlined className="nav-icon" />
					) : (
						<MenuFoldOutlined className="nav-icon" />
					)}
				</div>
			)}
		</>
	);
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, sideNavTheme, navType, mobileNav } = theme;
	return { navCollapsed, sideNavTheme, navType, mobileNav };
};

export default connect(mapStateToProps, {
	toggleCollapsedNav,
	onMobileNavToggle,
})(SideNav);
